import { render, staticRenderFns } from "./Date.global.vue?vue&type=template&id=ef2881c2&scoped=true&lang=pug&"
import script from "./Date.global.vue?vue&type=script&lang=ts&"
export * from "./Date.global.vue?vue&type=script&lang=ts&"
import style0 from "./Date.global.vue?vue&type=style&index=0&id=ef2881c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2881c2",
  null
  
)

export default component.exports